import React from 'react';
import { Link } from 'react-router-dom';
import { LAST_REVIEWED, CRM, formatarData } from '../data/revision';

const rows = [
  { key: 'O', label: 'Abertura ocular', value: '1–4' },
  { key: 'V', label: 'Resposta verbal', value: '1–5' },
  { key: 'M', label: 'Resposta motora', value: '1–6' },
];

export default function Hero() {
  return (
    <section className="glasgow-hero" aria-labelledby="hero-title">
      <div className="glasgow-hero__copy">
        <span className="glasgow-hero__eyebrow">Avaliação rápida do nível de consciência</span>
        <h1 id="hero-title">Escala de Glasgow: calculadora e tabela da ECG</h1>
        <p className="glasgow-hero__lead">
          Some abertura ocular, resposta verbal e resposta motora para obter o escore da Escala de Coma de Glasgow. A calculadora também permite registrar itens não testáveis e acrescentar a reatividade pupilar para a ECG-P.
        </p>

        <div className="glasgow-hero__actions">
          <Link className="button button--ghost" to="/tabela">Consultar tabela</Link>
        </div>

        <div className="glasgow-hero__trust" aria-label="Informações de confiança">
          <span>Revisão médica</span>
          <span>Processamento local</span>
          <span>{formatarData(LAST_REVIEWED)} · {CRM}</span>
        </div>
      </div>

      <aside className="sr-only" aria-label="Estrutura da Escala de Glasgow">
        <div>
          <span>ECG / GCS</span>
          <strong>3–15</strong>
        </div>
        <div className="hero-structure-list">
          {rows.map((row) => (
            <div key={row.key}>
              <span>{row.key}</span>
              <span>{row.label}</span>
              <strong>{row.value}</strong>
            </div>
          ))}
        </div>
        <div>
          <span>O + V + M</span>
          <strong>→ escore total</strong>
        </div>
        <p>Registre os componentes individualmente; se algum item for não testável, não force uma soma total.</p>
      </aside>
    </section>
  );
}
